import { Progress } from '@chakra-ui/progress';
import clsx from 'clsx';
import React from 'react';

export default function SKProgress({ value, ...rest }) {
  return (
    <Progress
      value={value || 0}
      colorScheme="brand"
      borderRadius={'15px'}
      {...rest}
      border="1px solid #FFFFFF"
    />
  );
}
